import React from 'react';

class PreOrder extends React.Component {
  render() {
    return <div className='dms-body'>
      {this.props.children}
    </div>
  }
};
export default PreOrder;


// WEBPACK FOOTER //
// ./src/routes/preOrder/index.js